
const { doExec } = require('./request')

module.exports = {
    // 古往今来
    findHistoricList (opts) {
        return doExec(`mobile/about/beforeOrSince/byType/${opts.typeId}`, opts, null, 'get')
    },
    // 历代祖师列表
    findFormerList (opts) {
        return doExec(`mobile/about/master/${opts.typeId}`, opts, null, 'get')
    },
    // 历代祖师详情
    getFormerDetail (opts) {
        return doExec(`mobile/about/master/detail/${opts.id}`, opts, null, 'get')
    },
    // 四方上下文章列表
    // findPositionList (opts) {
    //     return doExec(`mobile/about/routeLine/${opts.typeId}`, opts, null, 'get')
    // },
    // 四方上下文章详情
    // getPositionDetail (opts) {
    //     return doExec(`mobile/about/routeLine/details/${opts.id}`, opts, null, 'get')
    // },
    //四方上下列表
    findPositionList (opts) {
        return doExec(`/mobile/about/getAll`, opts, null, 'get')
    },
    // 四方上下文章详情
    getPositionDetail (opts) {
        return doExec(`/mobile/about/getAllData/${opts.pid}`, opts, null, 'get')
    },
    //坐标点详情
    getDetail(opts){
        return doExec(`/mobile/about/getDetailsData/${opts.id}`, opts, null, 'get')
    },
}